import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/SectionHeader";
import { EXPERIENCE, TRANSFERABLE_SKILLS } from "@/data/content";
import { Briefcase, MapPin, MoveRight } from "lucide-react";

export const Experience = () => (
    <section id="experience" data-testid="experience-section" className="scroll-mt-20 py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeader
                chapter="05"
                kicker="Career"
                title="Professional Experience"
                testId="experience-heading"
            />

            <Reveal>
                <article
                    data-testid="experience-job-card"
                    className="border border-white/10 bg-surface/70 p-8 transition-[border-color,box-shadow] duration-500 hover:border-neon/30 md:p-10"
                >
                    <div className="flex flex-wrap items-start justify-between gap-4">
                        <div>
                            <div className="mb-3 flex items-center gap-3">
                                <span className="flex h-10 w-10 items-center justify-center border border-neon/30 bg-neon/5 text-neon">
                                    <Briefcase size={17} strokeWidth={1.5} />
                                </span>
                                <span className="border border-white/10 bg-black/30 px-3 py-1 font-mono2 text-xs text-zinc-400">
                                    {EXPERIENCE.period}
                                </span>
                            </div>
                            <h3 className="font-display text-2xl font-extrabold tracking-tighter text-zinc-100 sm:text-3xl">
                                {EXPERIENCE.title}
                            </h3>
                            <p className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 font-mono2 text-sm text-zinc-400">
                                <span className="text-neon">{EXPERIENCE.company}</span>
                                <span className="flex items-center gap-1.5 text-zinc-500">
                                    <MapPin size={13} strokeWidth={1.5} />
                                    {EXPERIENCE.location}
                                </span>
                            </p>
                        </div>
                    </div>
                    <ul className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
                        {EXPERIENCE.bullets.map((bullet) => (
                            <li key={bullet.slice(0, 32)} className="flex items-start gap-3 border border-white/5 bg-black/20 p-4 text-sm leading-relaxed text-zinc-400">
                                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 bg-neon/70" />
                                {bullet}
                            </li>
                        ))}
                    </ul>
                </article>
            </Reveal>

            <Reveal delay={0.15} className="mt-16">
                <div className="border border-cyber/20 bg-cyber/[0.03] p-8 md:p-10">
                    <div className="mb-8 flex items-center gap-4">
                        <span className="h-px w-10 bg-cyber/50" aria-hidden="true" />
                        <h3
                            data-testid="transferable-skills-heading"
                            className="font-display text-xl font-extrabold uppercase tracking-tight text-zinc-100 sm:text-2xl"
                        >
                            Transferable Technical Skills
                        </h3>
                    </div>
                    <div className="space-y-3">
                        {TRANSFERABLE_SKILLS.map(([from, to], i) => (
                            <Reveal key={from} delay={i * 0.07}>
                                <div
                                    data-testid={`transferable-skill-${i + 1}`}
                                    className="group grid grid-cols-1 items-center gap-2 border border-white/5 bg-black/30 px-5 py-4 transition-[border-color] duration-300 hover:border-cyber/30 sm:grid-cols-[1fr_auto_1fr] sm:gap-4"
                                >
                                    <span className="font-mono2 text-sm text-zinc-300">{from}</span>
                                    <MoveRight size={16} strokeWidth={1.5} className="text-cyber transition-transform duration-300 group-hover:translate-x-1 max-sm:rotate-90" />
                                    <span className="font-mono2 text-sm text-cyber sm:text-right">{to}</span>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                    <p className="mt-6 font-mono2 text-[11px] uppercase tracking-[0.2em] text-zinc-600">
                        Industrial maintenance experience — applied to a security mindset
                    </p>
                </div>
            </Reveal>
        </div>
    </section>
);
